'use es6';

import { getCampaigns, getSfdcSettings } from 'FormsUI/api/SalesforceCampaigns';
function createAction(name) {
  return `@@salesforceCampaigns/${name}`;
}
export const REQUEST_CAMPAIGNS = createAction('REQUEST_CAMPAIGNS');
export const RECEIVE_CAMPAIGNS = createAction('RECEIVE_CAMPAIGNS');
export const SUCCEED_GETTING_CAMPAIGNS = createAction('SUCCEED_GETTING_CAMPAIGNS');
export const FAIL_GETTING_CAMPAIGNS = createAction('FAIL_GETTING_CAMPAIGNS');
export const REQUEST_SFDC_SETTINGS = createAction('REQUEST_SFDC_SETTINGS');
export const RECEIVE_SFDC_SETTINGS = createAction('RECEIVE_SFDC_SETTINGS');
export const SUCCEED_GETTING_SFDC_SETTINGS = createAction('SUCCEED_GETTING_SFDC_SETTINGS');
export const FAIL_GETTING_SFDC_SETTINGS = createAction('FAIL_GETTING_SFDC_SETTINGS');

// Action creators
function requestCampaigns() {
  return {
    type: REQUEST_CAMPAIGNS
  };
}
function receiveCampaigns(campaigns) {
  return {
    type: RECEIVE_CAMPAIGNS,
    campaigns
  };
}
function succeedGettingCampaigns() {
  return {
    type: SUCCEED_GETTING_CAMPAIGNS
  };
}
function failGettingCampaigns() {
  return {
    type: FAIL_GETTING_CAMPAIGNS
  };
}
function requestSfdcSettings() {
  return {
    type: REQUEST_SFDC_SETTINGS
  };
}
function receiveSfdcSettings(settings) {
  return {
    type: RECEIVE_SFDC_SETTINGS,
    settings
  };
}
function succeedGettingSfdcSettings() {
  return {
    type: SUCCEED_GETTING_SFDC_SETTINGS
  };
}
function failGettingSfdcSettings() {
  return {
    type: FAIL_GETTING_SFDC_SETTINGS
  };
}
export function fetchSfdcCampaigns() {
  return dispatch => {
    dispatch(requestCampaigns());
    getCampaigns().then(response => {
      dispatch(succeedGettingCampaigns());
      dispatch(receiveCampaigns(response));
    }, error => {
      dispatch(failGettingCampaigns(error.xhr));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}
export function fetchSfdcSettings() {
  return dispatch => {
    dispatch(requestSfdcSettings());
    getSfdcSettings().then(response => {
      dispatch(succeedGettingSfdcSettings());
      if (response.syncEnabled) {
        dispatch(fetchSfdcCampaigns());
      }
      dispatch(receiveSfdcSettings(response));
    }, error => {
      dispatch(failGettingSfdcSettings(error.xhr));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}